<template>
  <span
    v-if="label"
    class="caption-bold flex items-center gap-2 text-static-accent-hi"
    data-spec="sales-label"
    data-test="product-sales-label"
  >
    <IconFireFilled aria-hidden="true" height="16" width="16" />
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { SalesBucket } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconFireFilled } from '@ds/icons/IconFireFilled'

import translations from './SalesLabel.translations'

const SALES_BUCKET_THRESHOLDS: Record<SalesBucket, number> = {
  '100_plus': 100,
  '300_plus': 300,
  '1000_plus': 1000,
}

// ProductCardContent decides eligibility; this component only formats.
const { salesBucket } = defineProps<{
  salesBucket?: SalesBucket
}>()

const i18n = useI18n()

const label = computed(() => {
  if (!salesBucket) return undefined

  return i18n(translations.soldCountLabel, {
    bucket: i18n.number(SALES_BUCKET_THRESHOLDS[salesBucket]),
  })
})
</script>
